var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/img_wallpaper.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-download"
  }, [_c('a', {
    attrs: {
      "href": "static/assets/images/img_higashimura1920x1080.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_wallpaper001.svg"),
      "alt": "1920×1080"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/assets/images/img_higashimura1366x768.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_wallpaper002.svg"),
      "alt": "1366×768"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/assets/images/img_higashimura1280x1024.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_wallpaper003.svg"),
      "alt": "1280×1024"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/assets/images/img_higashimura1080x1920.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_wallpaper004.svg"),
      "alt": "iPhone"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "static/assets/images/img_higashimura2160x1920.jpg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_wallpaper005.svg"),
      "alt": "Android"
    }
  })])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a83480a0","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wallpaper.vue
// module id = 79
// module chunks = 0